import React from "react";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import GreenOJSection from "./GreenOJSection";
import BatchesPage from "./BatchesPage";
import LabAccessSection from "./LabSection";
import Footer from "./Footer";
import FAQSection from "./FAQ";
import Syllabus from "./Syllabus";
import AlumniSection from "./Alumni";

const Home = () => {
  return (
    <main className="home-shell">
      <HeroSection />
      <AboutSection />
      <GreenOJSection />
      <BatchesPage />
      <Syllabus />
      <AlumniSection />
      <FAQSection />
      <LabAccessSection />
      <Footer />
    </main>
  );
};

export default Home;
